module.exports = __webpack_public_path__ + "static/media/portfolio-ide.a4157308.png";